interface ICreateIntersectionObserverProps {
  element: Element;
  action: (entries: IntersectionObserverEntry[]) => void;
}

export interface ICreateIntersectionObserverPromise {
  disconnect: () => void;
}

export const createIntersectionObserverPromise = ({
  element,
  action,
}: ICreateIntersectionObserverProps): ICreateIntersectionObserverPromise => {
  const intersected: IntersectionObserver = new IntersectionObserver(
    (entries) => {
      action(entries);
    }
  );

  intersected.observe(element);
  return {
    disconnect: () => {
      intersected?.disconnect();
    },
  };
};
